// Standard
//import "bootstrap"; // nicht so! nur importieren, was wir brauchen

//so:
//import Alert from 'bootstrap/js/dist/alert'
// or, specify which plugins you need:
import {Collapse, Dropdown } from 'bootstrap'

// import Collapse from 'bootstrap/js/dist/collapse'
// import "bootstrap-datepicker"; // ES Module

// import datepicker from "bootstrap-datepicker";


import "./custom.js";

// Modules
import "./modules/module-hero-image/module-hero-image.js";  
import "./modules/module-hero-swiper/module-hero-swiper.js";  

import "./modules/module-project-swiper/module-project-swiper.js";

import "./modules/uo-password-toggle/uo-password-toggle.js";